// Sample Store - Notes
// Samp Spotlights


const SampleNotes =  [
  {
    
    id: 'note_0',
    
    noteHolderType: 'topics',
    noteHolderId: 'junkyard',

    noteContent: "<div>Don't know where to put something ... </div><div>Put it here in the <span class=\"ql-size-large\" style=\"color: rgb(107, 36, 178);\">Junkyard</span>.</div>",

    noteDate: '2020-11-01T11:16:20.619Z',
    // lastEdit:  "2020-11-01T11:16:20.619Z",  // September 14

    noteKeywordArray: [],
    peopleArray: [], 
    noteCatgory : ''
   
  },



  {
    
    id: 'note_1',
    
    noteHolderType: 'spotlights',
    noteHolderId: 'spot_1',

    noteContent: "<p>You tube how to :   <a href=\"https://www.youtube.com/watch?v=PkvKO8GchyE\" rel=\"noopener noreferrer\" target=\"_blank\">https://www.youtube.com/watch?v=PkvKO8GchyE</a></p>",

    noteDate: '2020-11-01T11:16:20.619Z',
    // lastEdit:  "2020-11-01T11:16:20.619Z",  // September 14

    noteKeywordArray: ['videos'],
    peopleArray: [], 
    noteCatgory : 'personal project'
   
  },

  {
    
    id: 'note_2',
    
    noteHolderType: 'spotlights',
    noteHolderId: 'spot_4',

    noteContent: "<p>Passport filing deadline - <u style=\"color: rgb(0, 102, 204);\">Tuesday</u></p>",

    noteDate: '2020-11-01T11:16:20.619Z',
    // lastEdit:  "2020-11-01T11:16:20.619Z",  // September 14

    noteKeywordArray: ['to do', 'vacation'],
    peopleArray: [], 
    noteCatgory : 'family'

   
  },


  {
    
    id: 'note_3',
    
    noteHolderType: 'tasks',
    noteHolderId: 'spot_1_task_1',

    noteContent: "note-3 for task 1, task 1 - build deck - >  2 keywords test and idea",

    noteDate: '2020-11-01T11:16:20.619Z',
    // lastEdit:  "2020-11-01T11:16:20.619Z",  // September 14

    noteKeywordArray: [],
    peopleArray: [], 
    noteCatgory : 'personal project'
   
  },

  {
    
    id: 'note_4',
    
    noteHolderType: 'spotlights',
    noteHolderId: 'spot_2',

    noteContent: "Get marketing projections from Cybil.",

    noteDate: '2020-11-01T11:16:20.619Z',
    // lastEdit:  "2020-11-01T11:16:20.619Z",  // September 14

    noteKeywordArray: ['marketing', 'to do', 'project team'],
    peopleArray: [], 
    noteCatgory : 'work'
   
  },

  
  {
    
    id: 'note_5',
    
    noteHolderType: 'tasks',
    noteHolderId: 'task_2',

    noteContent: 'spotlight 1,  - Build Backyard - no keywords ...etc.',

    noteDate: '2020-11-01T11:16:20.619Z',
    // lastEdit:  "2020-11-01T11:16:20.619Z",  // September 14

    noteKeywordArray: [],
    peopleArray: [], 
    noteCatgory : ''
   
  },

  {
    
    id: 'note_6',
    
    noteHolderType: 'topics',
    noteHolderId: 'topic_1',

    noteContent: '<div>Steve - ME designs <span style="color: rgb(161, 0, 0);">888-555-1212</span> ,etc.</div>',

    noteDate: '2021-02-16T06:08:53.000Z',
    // lastEdit:  "2020-11-01T11:16:20.619Z",  // September 14

    noteKeywordArray: [],
    peopleArray: ['Steve - Jerry friend'], 
    noteCatgory : ''
   
  },

  {
    
    id: 'note_7',
    
    noteHolderType: 'topics',
    noteHolderId: 'topic_1',

    noteContent: '<div>Wakeboard bindings</div><div><a href="https://www.evo.com/reviews/wake/best-wakeboard-bindings" rel="noopener noreferrer" target="_blank">https://www.evo.com/reviews/wake/best-wakeboard-bindings</a></div>',

    noteDate:  '2021-01-03T06:08:53.000Z',
    // lastEdit:  "2020-11-01T11:16:20.619Z",  // September 14

    noteKeywordArray: [],
    noteCatgory : ''
   
  },

  {
    
    id: 'note_8',
    
    noteHolderType: 'topics',
    noteHolderId: 'topic_1',

    noteContent:  '<div>Patent search web site</div><div><a href="https://www.evo.com/reviews/wake/best-wakeboard-bindings" rel="noopener noreferrer" target="_blank">https://www.evo.com/reviews/wake/best-wakeboard-bindings</a></div>',

    // '<div>Patent search web site</div><div><a href="https://www.evo.com/reviews/wake/best-wakeboard-bindings" rel="noopener noreferrer" target="_blank"https://www.uspto.gov/patents/search</a></div>',

    noteDate:  '2021-02-03T06:08:53.000Z',
    // lastEdit:  "2020-11-01T11:16:20.619Z",  // September 14

    noteKeywordArray: [],
    noteCatgory : ''
   
  },
  {
    
    id: 'note_9',
    
    noteHolderType: 'topics',
    noteHolderId: 'topic_2',

    noteContent: '<div>boot types</div><div><a href="https://www.wakesports.com/blogs/updates/kinds-of-wakeboard-boots-and-bindings" rel="noopener noreferrer" target="_blank">https://www.wakesports.com/blogs/updates/kinds-of-wakeboard-boots-and-bindings</a></div>',

    noteDate:  '2021-03-03T06:08:53.000Z',
    // lastEdit:  "2020-11-01T11:16:20.619Z",  // September 14

    noteKeywordArray: [],
    noteCatgory : ''
   
  }
 

 
 ] // end notes  ============================================
 
 
 
 
 
 
 
 export default SampleNotes